import { useNavigate } from 'react-router-dom';

export function ProductsSection() {
  const navigate = useNavigate();
  
  const products = [
    {
      id: 1,
      name: '딥슬립 데일리 셀 솔루션',
      description: '멸균 처리된 상태에서 숙성된 화학원료를 무첨가한 에센셜을 주요 성분으로, 하루의 끝에 피부와 마음에 휴식을 선사합니다.',
      image: 'https://static.readdy.ai/image/e9a77f6954ec1ab9763a92a5437cc602/b34472748a63f07a179889d8b1766b7c.jpeg',
      features: ['멸균 처리', '화학원료 무첨가', '피부 진정', '마음의 휴식'],
      route: '/product/1'
    },
    {
      id: 2,
      name: 'X2 / Y2 데오드란트',
      description: '자연 유래 성분으로 피부 밸런스를 유지하며, 순수하고 깨끗한 향으로 하루를 리프레시합니다.',
      image: 'https://static.readdy.ai/image/e9a77f6954ec1ab9763a92a5437cc602/a0ebcb4c100247b80930e817e904e7d3.png',
      features: ['자연 유래 성분', '피부 밸런스', '순수한 향', '데일리 케어'],
      route: '/product/2'
    }
  ];

  return (
    <section id="products" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h3 className="text-4xl font-bold text-gray-900 mb-4">
            Signature Collection
          </h3>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            자연의 순수한 에너지를 담은 라코스벨의 대표 제품들을 만나보세요
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-product-shop>
          {products.map((product) => (
            <div key={product.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300">
              <div className="aspect-square overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-8">
                <h4 className="text-2xl font-bold text-gray-900 mb-4">{product.name}</h4>
                <p className="text-gray-600 mb-6 leading-relaxed">{product.description}</p>
                
                <div className="grid grid-cols-2 gap-3 mb-6">
                  {product.features.map((feature, index) => (
                    <div key={index} className="flex items-center space-x-2">
                      <div className="w-2 h-2 bg-emerald-500 rounded-full"></div>
                      <span className="text-sm text-gray-700">{feature}</span>
                    </div>
                  ))}
                </div>

                <button 
                  onClick={() => navigate(product.route)}
                  className="w-full bg-emerald-600 text-white py-3 rounded-lg hover:bg-emerald-700 transition-colors font-medium cursor-pointer whitespace-nowrap"
                >
                  제품 상세보기
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
